import { TrackingEvent } from '../types/tracking.types.ts';

export const mapTrackingEventAddCommonAnalyticsData = (event: TrackingEvent): TrackingEvent => {
  return {
    ...event,
    data: {
      ...(event.data ?? {}),
      // TODO: When we have authentication, we need to add the session number to all events
      // sessionNumber: 1,
    },
  } as TrackingEvent;
};
